<script setup>
  import { ref, onMounted, computed, onBeforeUnmount } from "vue";
  import SubAccordion from "./SubAccordion.vue";
  const DownloadData = ref([]);
  const errorFetching = ref(false);
  const searchText = ref('');
  const showDropdown = ref(false);
  const openAccordionsByDefault = ref(false);
  const allSearchResults = ref([
    { id: 1, name: 'Tile A Collection' },
    { id: 2, name: 'Modern Styles' },
    { id: 3, name: 'Classic Tiles' },
    { id: 4, name: 'Collection B Design' },
    { id: 5, name: 'Another Style Option' },
  ]);
  let timer;

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  const filteredResults = computed(() => {
    if (!searchText.value) {
      return allSearchResults.value;
    }
    const searchLower = searchText.value.toLowerCase();
    return allSearchResults.value.filter(item =>
      item.name.toLowerCase().includes(searchLower)
    );
  });
  const debounce = function (callback, delay) {

    clearTimeout(timer);

    timer = setTimeout(() => {

      callback();
    }, delay)

  }
  const handleSearchInput = () => {
    showDropdown.value = searchText.value.length > 0;
    let url = new URL(window.location.href);
    url.searchParams.set('q', searchText.value);
    let novaUrlComQuerystring = url.toString();
    window.history.pushState({path: novaUrlComQuerystring}, '', novaUrlComQuerystring)
    debounce(() => {
      fetchDownloadData();
    }, 250);
  };

  const clearSearchInput = () => {
    searchText.value = '';
    showDropdown.value = false;
    handleSearchInput();

  };

  const selectSearchResult = (item) => {
    searchText.value = item.name;
    showDropdown.value = false;
  };

  const performSearch = () => {
    console.log('A pesquisar por:', searchText.value);
    showDropdown.value = false;
  };


  const searchInputWrapper = ref(null);
  onMounted(() => {
    document.addEventListener("click", handleClickOutside);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("click", handleClickOutside);
  });

  const handleClickOutside = (event) => {
    if (searchInputWrapper.value && !searchInputWrapper.value.contains(event.target)) {
      showDropdown.value = false;
    }
  };

  const fetchDownloadData = async () => {
    errorFetching.value = false;
    DownloadData.value = [];
    try {
      console.log("Fetching data from: /api/getDownloads");
      const apiUrl = new URL(window.location.origin + '/api/getDownloads' );
      const  url = new URL(window.location.href);
      if (url.searchParams.has('q')){
        apiUrl.searchParams.set('q', url.searchParams.get('q'))
      }
      const cacheKey = `downloads_cache:${apiUrl.toString()}`;
      const cachedData = localStorage.getItem(cacheKey);
      if (cachedData) {
        DownloadData.value = JSON.parse(cachedData);
      }
      const response = await fetch(apiUrl);
      console.log("API Response Status:", response.status);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Parsed Data:", data);
      localStorage.setItem(cacheKey, JSON.stringify(data));
      DownloadData.value = data;
    } catch (error) {
      console.error("Error fetching download data:", error);
      errorFetching.value = true;
    } finally {
      setTimeout(() => {
      }, 100);
    }
  };

  onMounted(() => {
    const  url = new URL(window.location.href);
    if (url.searchParams.has('q')){
      searchText.value =  url.searchParams.get('q');
      openAccordionsByDefault.value = true;
    }
    fetchDownloadData();
  });
</script>

<template>
  <div class="main-download-container">
    <div class="container-general">
      <div class="search-section">
        <div class="search-input-wrapper" ref="searchInputWrapper">
          <input
            type="text"
            id="mainSearchInput"
            placeholder="Search tiles, collections, or styles..."
            v-model="searchText"
            @keyup="handleSearchInput"
            autocomplete="off"
          />
          <button
            id="clearSearchBtn"
            class="clear-button"
            @click="clearSearchInput"
            :class="{ active: searchText.length > 0 }"
            v-show="searchText.length > 0"
          >
            &#x2715;
          </button>
          <button
            class="search-button"
            id="search-btn"
            :class="{ active: searchText.length > 0 }"
            @click="performSearch"
          >
            {{ trans('all.Search') }}
          </button>

        </div>
      </div>

      <div class="accordion-root">
        <div v-if="errorFetching" class="error-message">
          <p>Error loading data. Please try again.</p>
        </div>
        <TransitionGroup v-else-if="!isLoading" name="list-download" tag="div">
          <SubAccordion
            v-for="item in DownloadData"
            :key="item.id"
            :item="item"
            :level="0"
            :open-by-default="openAccordionsByDefault" />
        </TransitionGroup>

        <div v-else-if="!DownloadData.length && !errorFetching" class="no-results">
          <p>No downloads were found.</p>
        </div>
      </div>
    </div>


  </div>
</template>

<style scoped>


</style>
